import { DEVICES } from "../../../constants/constants";
import { useTitle } from "../../../hooks/common/useTitle";
import { ListHandler } from "../../lists/ListHandler";

export const DevicesPage = () => {
  useTitle("BNPL");
  return (
    <div className="p15">
      <ListHandler source={DEVICES} />
    </div>
  );
};